import React from 'react';

const Input = React.forwardRef(({ className = '', ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={`w-full px-3 py-2 bg-white border border-gray-200 rounded-lg text-[13px] text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-tenant-primary/20 focus:border-tenant-primary transition-colors ${className}`}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
